export default __webpack_public_path__ + "static/media/Vector (2).05b20c67.svg";